import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  UpdateBidReportEntryByIdMutation,
  UpdateBidReportEntryByIdMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { updateBidReportAnswerById } from "lib/hooks/api/bid/answers/useGetBidReportAnswers";
import { useGraphQlMutation } from "lib/hooks/api/useGraphQlClient";

export const updateBidReportEntryById = graphql(`
  mutation UpdateBidReportEntryById($input: UpdateBidReportEntryRequest!) {
    updateBidReportEntryById(UpdateBidReportEntryRequest: $input) {
      bidReportId
      answer {
        answer
      }
    }
  }
`);

export function useUpdateBidReportEntryById(
  options?: UseMutationOptions<
    UpdateBidReportEntryByIdMutation,
    unknown,
    UpdateBidReportEntryByIdMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  const { data, ...rest } = useGraphQlMutation(updateBidReportEntryById, {
    ...options,
    onSuccess: (data, vars, ctx) => {
      // Patch the edited answer straight into the cache so the report reflects it
      // without a refetch.
      updateBidReportAnswerById(
        queryClient,
        data.updateBidReportEntryById.bidReportId,
        vars.input.id,
        vars.input.answer,
      );

      options?.onSuccess?.(data, vars, ctx);
    },
  });

  return { data: data?.updateBidReportEntryById, ...rest };
}
